import React from 'react';
import get from 'lodash/get';

import Toast from './toast';

import { bugsnagNotify } from '../../util';
import { RESULT__ITEM_SHAPE } from '../../redux/constants';
import * as css from './toast.scss';

const toastIsVisible = (result) => {
  const rewardStatus = get(result, 'rewardStatus');

  switch (rewardStatus) {
    case 'unavailable':
      return true;

    case undefined:
    case 'none':
    case 'available':
      return null;

    default:
      bugsnagNotify(new Error('Invalid rewardStatus'), { metadata: { rewardStatus } });
      return null;
  }
};

const ToastRewards = ({ result }) =>
  toastIsVisible(result) && (
    <Toast bsStyle="danger" className={css.rewards}>
      <i className={`fa fa-exclamation-circle ${css.exclamation}`} />
      There are no more rewards for this survey.
    </Toast>
  );

ToastRewards.propTypes = {
  result: RESULT__ITEM_SHAPE.isRequired,
};

export default ToastRewards;
